import React, { ReactNode } from 'react';
import { NiceSignInScreen } from '../auth/NiceSignInScreen';

interface AuthGateProps {
  isLoading: boolean;
  needsNiceLink: boolean;
  isAuthenticated: boolean;
  error: string | null;
  onSignInWithNice: () => Promise<void>;
  children: ReactNode;
}

export function AuthGate({
  isLoading,
  needsNiceLink,
  isAuthenticated,
  error,
  onSignInWithNice,
  children,
}: AuthGateProps) {
  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="spinner" />
      </div>
    );
  }

  if (needsNiceLink) {
    return <NiceSignInScreen onSignInWithNice={onSignInWithNice} error={error} />;
  }

  if (!isAuthenticated && error) {
    return (
      <div className="app-loading">
        <p>{error}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <NiceSignInScreen onSignInWithNice={onSignInWithNice} error={error} />;
  }

  return <>{children}</>;
}
